import dayjs from "dayjs";
export default function getMonthForRender(NewDate) {
    const calcNextMonthDays = () => {
        const isShortCalendar = firstDayInCalendar ? (lastDayInPrevMonth - firstDayInCalendar) + daysInThisMonth + 1 <= 35 : firstDayInCalendar + daysInThisMonth + 1 <= 35;
        if (isShortCalendar) {
            return firstDayOfMonth ? 35 - daysInThisMonth - (firstDayOfMonth - 1) : 35 - daysInThisMonth;
        }
        return firstDayOfMonth ? 42 - daysInThisMonth - (firstDayOfMonth - 1) : 42 - daysInThisMonth;
    };
    const daysInThisMonth = dayjs(NewDate).daysInMonth();
    const firstDayOfMonth = dayjs(NewDate).date(1).day() || 7;
    const lastDayInPrevMonth = dayjs(NewDate).date(0).date();
    const firstDayInCalendar = firstDayOfMonth > 1 ? lastDayInPrevMonth - (firstDayOfMonth - 2) : 0;
    const daysFromNextMonth = calcNextMonthDays();
    const arrOfCurrentMonth = [];
    const arrOfPrevMonth = [];
    const arrOfNextMonth = [];
    if (firstDayInCalendar) {
        for (let j = firstDayInCalendar; j <= lastDayInPrevMonth; j++) {
            arrOfPrevMonth.push({
                id: j,
                date: dayjs(NewDate).date(j).format('YYYY-MM-DD')
            });
        }
    }
    ;
    for (let i = 1; i <= daysInThisMonth; i++) {
        arrOfCurrentMonth.push({
            id: i,
            date: dayjs(NewDate).date(i).format('YYYY-MM-DD')
        });
    }
    ;
    for (let k = 1; k <= daysFromNextMonth; k++) {
        arrOfNextMonth.push({
            id: k,
            date: dayjs(NewDate).date(k).format('YYYY-MM-DD')
        });
    }
    ;
    return {
        prevMonth: [...arrOfPrevMonth],
        currentMonth: [...arrOfCurrentMonth],
        nextMonth: [...arrOfNextMonth]
    };
}
